import { default as Area } from './Area';
import { default as AreaList } from './AreaList';
import { default as Base } from './Base';
import { default as Spot } from './Spot';

export { Base, AreaList, Area, Spot };



// WEBPACK FOOTER //
// ./src/views/index.js